
var resources = angular.module('resources', [ 'classy', 'authService', 'postService', 'purgeService',
    'information', 'suggestions', 'parentFeedback']);
resources.classy.controller({
	name: 'ResourcesController', 
	inject: ['$scope', '$state', 'authServiceFactory', 'RestService', 'deviceDetector', 'FeeAgreementModelService'],
    init: function() {
        this.$.auth = this.authServiceFactory.getAuth();
        this.$.versionNo = versionNo;
        this.$.deviceDetector = this.deviceDetector;
        this.$.selectedSection = this.$state.current.url;
        this.$.feeinfo = this.FeeAgreementModelService.get()[0];
        console.log(this.$.feeinfo);
        this.$.appFee = this.$.feeinfo.appFee;
    },
    setActiveSection: function(state)
    {
        this.$.selectedSection = state;
    }
});

stateProviders.push({
    name: 'schoolside.resources',
    url: '/resources',
    controller: 'ResourcesController',
    abstract: true,
    templateUrl: 'fast/submodules/schoolside/resources/resources.html?v=' + versionNo,
    resolve: {
    	feeinfo: function(FeeAgreementModelService) {
            return FeeAgreementModelService.get();
        }
    }
});